import axios from 'axios';
import { apiPOST } from './api';

export const s3FileUpload = async ({ url, file, contentType, contentDisposition, onUploadProgress }) => {
  const headers = {
    'Content-Type': contentType || 'application/octet-stream',
  };

  if (contentDisposition) {
    headers['Content-Disposition'] = contentDisposition;
  }

  const arrayBuffer = await file.arrayBuffer();

  return axios.request({
    method: 'put',
    url: url,
    data: arrayBuffer,
    headers,
    redirect: 'follow',
    onUploadProgress: onUploadProgress,
  });
};

export const generateS3Url = (fileName, bucket = null, options = {}) =>
  apiPOST('/aws/create-write-signed-url', {
    bucket,
    file_name: fileName,
    content_disposition: options.contentDisposition || null,
  });
